import Enum from 'easy-enums';

const KWorkflow = new Enum("Goal DesignAd DesignPostEngagement ImpactHub Publish");

// ImpactHub is now handled outside the main new ad workflow
export const WORKFLOW_STEPS = KWorkflow.values.filter(w => w !== KWorkflow.ImpactHub);

// Format-specific names for design stages of workflow
const design1Names = { video: 'Video', social: 'Splash', banner: 'Banner' };
const design2Names = { video: 'End Card', social: 'Post Engagement', banner: 'Post Engagement' };

export const titleForWorkflow = (workflow, advert) => {
	//	"Goal DesignAd DesignPostEngagement ImpactHub Publish"
	const fmt = advert && advert.format;
	switch(workflow) {
	case "Goal": return 'Aims';
	case KWorkflow.DesignAd: 
		return design1Names[fmt] || 'Design 1';
	case KWorkflow.DesignPostEngagement:
		return design2Names[fmt] || 'Design 2';
	case KWorkflow.ImpactHub: 
		return 'Impact Hub';
	case KWorkflow.Publish: 
		return 'Publish';
	}
	return workflow;
};

export default KWorkflow;
